export default {
    init() {
        this.event();
        $(window).resize();
    },
    event() {
        setTimeout(function () {
            let pageHeight = document.documentElement.scrollHeight,
                viewportHeight = document.documentElement.clientHeight;

            if (pageHeight > viewportHeight) {
                $(window).on('scroll resize', function () {
                    let winScroll = document.body.scrollTop || document.documentElement.scrollTop,
                        height = document.documentElement.scrollHeight - document.documentElement.clientHeight,
                        scrolled = (winScroll / height) * 100;

                    $('.c-indicator__fill').width(scrolled + '%')
                });
            } else {
                $('.c-indicator').hide();
            }
        });
    },
}



// WEBPACK FOOTER //
// ./scripts/components/indicator.js